module.exports = __webpack_public_path__ + "static/hamburgesa-de-sirlon-1-ef9371103aac84b7c54ee52ab458e70a.jpg";